export enum Plans {
  CreateTeam = 'CreateTeam',
  JoinTeam = 'JoinTeam',
  Individual = 'Individual',
}
